<template>
  <div class="offen-question">
    <div class="header">
    <TopBar :title ="$t('mine.cjwt')" />

      <div class="content" v-for="(item,index) of list" @click="handleCollapse(item,index)">
        <div class="collapse">
          <van-button round block type="info">{{item.title}}</van-button>
          <div class="icon">
            <van-icon name="arrow-down" v-show="!item.open" />
            <van-icon name="arrow-up" v-show="item.open" />
          </div>
          <div class="block" v-if="item.open" v-html="item.desc"></div>
        </div>
      </div>
      <div class="tips">
        {{$t('cjwt.wxts6')}}
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import TopBar from '@/common/top-bar/index.vue'

  export default {
    name: 'OffenQuestion',
    components: {
      TopBar
    },
    data () {
      return {
        list:[
          {
            title:this.$t('cjwt.rhcj'),
            desc:this.$t('cjwt.wxts7'),
            open:false
          },
          {
            title:this.$t('cjwt.wsmw1'),
            desc:this.$t('cjwt.QUESTION_ANSWER_2'),
            open:false
          },
          {
            title:this.$t('cjwt.wsmw2'),
            desc:this.$t('cjwt.QUESTION_ANSWER_3'),
            open:false
          },
          {
            title:this.$t('cjwt.wsmw3'),
            desc:this.$t('cjwt.QUESTION_ANSWER_4'),
            open:false
          },
          {
            title:this.$t('cjwt.wsmw4'),
            desc:this.$t('cjwt.QUESTION_ANSWER_5'),
            open:false
          }
        ]
      }
    },
    methods: {
      onClickLeft(){
        this.$router.go(-1)
      },
      handleCollapse(item,index){
        if(item.desc){
          this.list[index].open = !this.list[index].open
        }
      }
    },
    mounted () {
    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.offen-question{
    width: 100%;
    height: 100%;
    overflow: scroll;
    background-color: #F3F3F3;
    .content{
      padding: .4rem;
      .collapse{
        padding-bottom: .4rem;
        button{
          float: left;
          width:auto;
          height:.8rem;
          background: #FF7E00;
          border:1px solid #FF7E00;
          max-width: 80%;
        }
        .icon{
          float: right;
          color: #FF7E00;
          line-height:.8rem;
        }
        .block{
          display: block;
          clear : both;
          padding-top: .4rem;
          line-height:.6rem;
        }
      }
    }
    .tips{
      padding: .4rem;
      line-height:.4rem;
      color: #C75353;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/offenQuestion/OffenQuestion.vue